/**
 * This message means it was basically declined.
 */
export const MESSAGE_CREDIT_CARD_COULD_NOT_BE_AUTHENTICATED =
  'The credit card could not be authenticated.' + ' Please try again.';

/**
 * This message means there was probably some kind of system failure.
 *
 * We consider it declined but show a custom message here. If debug logging is
 * enabled, more info will be sent to the server debug log, even if the issue
 * happened on the client.
 */
export const MESSAGE_ERROR_CREDIT_CARD_COULD_NOT_BE_AUTHENTICATED =
  'An error occurred. The credit card could not be authenticated.' +
  ' Please try again.';

/**
 * Symbolic name of the action for performing a checkout using the standard credit card payment method.
 */
export const CHECKOUT_CREDIT_CARD_STANDARD = 'CHECKOUT_CREDIT_CARD_STANDARD';

/**
 * Symbolic name of the action for signing up a customer
 */
export const SIGNUP_CUSTOMER = 'SIGNUP_CUSTOMER';

export const BANK_TRANSFER = 'BANK_TRANSFER';
export const PAYPAL = 'PAYPAL';

export const UPDATE_AUTOSHIP = 'UPDATE_AUTOSHIP';
export const FREE_ORDER = 'FREE_ORDER';
export const CHECK_PAYMENT = 'CHECK_PAYMENT';
